/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.chart-area[_ngcontent-%COMP%]{padding-top:15px;margin-right:24px;margin-left:24px}.chart-area[_ngcontent-%COMP%]  achoo-line-chart chart{height:278px}.chart-area.print-mode[_ngcontent-%COMP%]{padding-top:5px;margin-right:8px;margin-left:8px}.chart-area.print-mode[_ngcontent-%COMP%]  achoo-line-chart chart{height:225px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-growth/follower-growth.component.scss.shim.ngstyle.js.pre-build-optimizer.js